<template>
  <div class="popup">
    <div class="popup_cover"></div>
    <div class="file-upload-popup">
      <div class="popup-header">
        <div class="popup_title">{{ props.등록구분 == '도장' ? props.도장구분 : props.등록구분 }} 등록</div>
        <img src="@/assets/images/close_btn.png" @click="closePopup(false)" class="close_icon" />
      </div>
      <div class="popup-body">
        <div style="display: flex;align-items: center;gap:10px;" v-if="props.도장구분 == '인감'">
          <input type="password" v-model="sealPassword" placeholder="비밀번호 입력" @keyup.enter="getSeal" :readonly="sealPwdFlag"/>
          <div class="pwd_chk_btn" @click="getSeal" v-if="!sealPwdFlag">확인</div>
        </div>
        <div class="popup_desc" v-if="props.등록구분 == '도장'">
          아래 박스 클릭 또는 마우스로 끌어오기 해주세요.
          <br/><span class="file-type-hint">(JPG, PNG 등 이미지 파일만 가능)</span>
        </div>
        <div class="popup_desc" v-else>
          아래 박스 클릭 또는 마우스로 끌어오기 해주세요.
          <br/><span class="file-type-hint">(JPG, PNG 등 이미지 또는 PDF 파일만 가능)</span>
        </div>
        <div class="file_upload_area" 
          @dragover.prevent="onDragOver"
          @dragleave.prevent="onDragLeave"
          @drop.prevent="onDrop"
          @click="pwdChk()"
        >
          <label v-if="file1 === null && !img" style="" >파일 첨부 +</label>
          <img v-if="file1 !== null && props.등록구분 == '사업자등록증'" src="@/assets/images/file_big_icon.png" />
          <div v-if="file1 === null && !img">또는<br/>파일놓기</div>
          <div v-if="file1 !== null && props.등록구분 == '사업자등록증'" >{{ file1?.name }}</div>
          <div v-if="oldSeq && img"><img :src="img"/></div>
          <div></div>
        </div>
        <input ref="fileInp" class="file_inp" type="file" @change="addFile($event)" :accept="props.등록구분 == '도장' ? 'image/*' : '.pdf, image/*'" />
      </div>
      <div class="popup-footer">
        <div class="popup_close_btn" @click="closePopup(false)">취소</div>
        <div class="popup_confirm_btn" @click="uploadFile">등록</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineEmits, defineProps, onMounted } from "vue";
import userAPI from "@/api/userAPI";

// Props 정의: 요청파일정보를 객체로 처리
const props = defineProps<{
  등록구분: string;
  도장구분: string | null | undefined;
  oldSeq: number;
}>();

const emit = defineEmits(["closePopup"]);
const img = ref('')
const sealPwdFlag = ref(false)
onMounted(async() => {
  if(props.도장구분 !== '인감') {
    getSeal()
  }
})

const getSeal = async() => {
  if (props.등록구분 === '도장' && props.도장구분 === '사용인감' && props.oldSeq) {
    const res = await userAPI.sealFile(props.oldSeq, props.도장구분, '');
    const blob = new Blob([res.data], { type: 'image/jpeg' });
    img.value = URL.createObjectURL(blob);
  } else if(props.등록구분 === '도장' && props.도장구분 === '인감') {
    await userAPI.sealCheck(sealPassword.value).then(async(res) => {
      if(res.data.data) {
        sealPwdFlag.value = true
        const res = await userAPI.sealFile(props.oldSeq, props.도장구분!, sealPassword.value);
        const blob = new Blob([res.data], { type: 'image/jpeg' });
        img.value = URL.createObjectURL(blob);
      }
    })
  }
}
const pwdChk = () => {
  if(props.도장구분 === '인감' && !sealPwdFlag.value) {
    alert('인감 비밀번호를 입력해주세요.')
    return
  }
  if (fileInp.value) {
    fileInp.value.click()
  }
}
// HTMLInputElement 타입을 명시적으로 지정
const fileInp = ref<HTMLInputElement>();

// Param 인터페이스 정의하여 param 타입 지정
// file1 타입을 File | null로 지정
const file1 = ref<File | null>(null);

const onDragOver = (event: DragEvent) => {
  event.preventDefault()
  ;(event.currentTarget as HTMLElement).classList.add('active')
  event.dataTransfer!.dropEffect = 'copy'
}
const onDragLeave = (event: DragEvent) => {
  (event.currentTarget as HTMLElement).classList.remove('active')
  event.preventDefault()
}

const onDrop = (event: DragEvent) => {
  if(props.도장구분 === '인감' && !sealPwdFlag.value) {
    alert('인감 비밀번호를 입력해주세요.')
    return
  }
  event.preventDefault()
  const files = event.dataTransfer!.files
  if (files.length > 0) {
    upload(files[0])
  }
}
const sealPassword = ref('')
const upload = (filedata: File) => {
  if (filedata === undefined) return

  for (let i = 0; i < document.getElementsByClassName('drop-zone').length; i++) {
    document.getElementsByClassName('drop-zone')[i].classList.remove('active')
  }
  if (filedata && filedata.size > 10 * 1024 * 1024) {
    alert('파일 크기는 10MB를 초과할 수 없습니다.')
    return
  }
  // 도장인 경우 이미지 파일 타입 검증 추가
  if (props.등록구분 == '도장' && !filedata.type.startsWith('image/')) {
    alert("도장은 이미지 파일만 업로드 가능합니다.");
    return;
  }
  if (props.등록구분 != '도장' && !(filedata.type.startsWith('image/') || filedata.type === 'application/pdf')) {
    alert("이미지 또는 PDF 파일만 업로드 가능합니다.");
    return;
  }
  file1.value = filedata
  
  if (filedata && filedata.type.startsWith('image/')) {
    img.value = URL.createObjectURL(filedata);
  }
    
}
// 파일 업로드 처리
const addFile = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0] || null;
  file1.value = file;
  
  // 도장인 경우 이미지 파일 타입 검증
  if (props.등록구분 == '도장' && file && !file.type.startsWith('image/')) {
    alert("도장은 이미지 파일만 업로드 가능합니다.");
    return;
  }
  
  if (props.등록구분 != '도장' && file && !(file.type.startsWith('image/') || file.type === 'application/pdf')) {
    alert("이미지 또는 PDF 파일만 업로드 가능합니다.");
    return;
  }
  file1.value = file;
  // 이미지 미리보기 생성
  if (file && file.type.startsWith('image/')) {
    img.value = URL.createObjectURL(file);
  }
};

const uploadFile = () => {
  if (!file1.value) {
    alert("파일을 첨부해주세요.");
    return;
  }
  // 도장인 경우 이미지 파일 타입 최종 검증
  if (props.등록구분 == '도장' && !file1.value.type.startsWith('image/')) {
    alert("도장은 이미지 파일만 업로드 가능합니다.");
    return;
  }
  // 도장이 아닌 경우 이미지 또는 PDF 파일 타입 검증
  if (props.등록구분 != '도장' && 
      !(file1.value.type.startsWith('image/') || file1.value.type === 'application/pdf')) {
    alert("이미지 또는 PDF 파일만 업로드 가능합니다.");
    return;
  }
  const fileParam = {
    등록구분: props.등록구분,
    도장구분: props.도장구분,
    인감비밀번호: sealPassword.value
  }
  if (props.도장구분 === '인감' && sealPassword.value === '') {
    alert('인감 비밀번호를 입력해주세요.')
    return
  }
  userAPI
    .uploadUserFile(fileParam, file1.value)
    .then((res) => {
      alert('파일이 등록되었습니다.')
      sealPassword.value = ''
      emit("closePopup", { popupType: "fileUpload", refresh:true });
    })
};
// 팝업 닫기 처리
function closePopup(refresh: boolean) {
  emit("closePopup", { popupType: "fileUpload", refresh: false });
}
</script>

<style scoped>

input[type="password"] {
  width: 70%;
  height: 39px;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #d0d0d0;
  background-color: #f6f7fb;
}
.pwd_chk_btn {
  width: 30%;
  height: 39px;
  background: #383838;
  color: #fff;
  border-radius: 4px;
  text-align: center;
  line-height: 39px;
  cursor: pointer;
}
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
}
.popup_cover {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}
.file-upload-popup {
  /* Add your styles here */
  left: 50%;
  position: fixed;
  background-color: white;
  width: 439px;
  background: white;
  top: calc(50% - 231.5px);
  left: calc(50% - 219.5px);
  border-radius: 11px;
}
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 71px;
  padding: 22px 27px 22px 40px;
  border-bottom: 1px solid #dbdbdb;
}
.popup_title {
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  letter-spacing: -0.05em;
  color: black;
}
.popup-body {
  /* margin-top: 10px; */
  padding: 40px;
}
.popup_desc {
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 14px;
  line-height: 20px;
  color: black;
  margin-bottom: 15px;
}
.file_title {
  border: 1px solid #d0d0d0;
  height: 39px;
  width: 100%;
  border-radius: 4px;
  padding-left: 12px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  margin-bottom: 15px;
}
.file_upload_area {
  height: 145px;
  border: 2px dashed #dbdbdb;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #838383;
  gap: 10px;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}
.file_upload_area > div > img {
  max-height: 105px;
  max-width: 105px;
}
.file_upload_area.active {
  background-color: #f0f8ff !important;
}
.file_upload_area:hover {
  background-color: #f0f0f0 !important;
}
.file_upload_area.upload {
  cursor: default;
}
.popup-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0px 40px 40px;
  gap: 10px;
}
.file_inp {
  width: 0px;
  height: 0px;
}
.popup_close_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ededed;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #383838;
  font-size: 14px;
  cursor: pointer;
}
.popup_confirm_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3382e9;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: white;
  font-size: 14px;
  cursor: pointer;
}
.close_icon {
  cursor: pointer;
}

.popup-body label {
  display: inline-block;
  text-align: center;
  width: 113px;
  height: 39px;
  padding: 9px 21px;
  border-radius: 4px;
  color: #000;
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid #d0d0d0;
  cursor: pointer;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
}
</style>
